import { ObjectTypes } from '@playbooks/action-cards-utils/src'
import { useTranslation } from '../contexts/localization/Localization'

function getCrmObjectName(objectType: ObjectTypes) {
  const { text } = useTranslation
  switch (objectType) {
    case ObjectTypes.Company:
      return text('company')
    case ObjectTypes.Opportunity:
      return text('opportunity')
    default:
      return text('contact')
  }
}

export default getCrmObjectName
